import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import Logo from '../../../components/Logo';
import { buildQrUrl } from '../../shared/WizardComponents';

const PROJECT_FIELDS = [
  { key: 'projectName', label: 'Project Name' },
  { key: 'projectNumber', label: 'Project Number' },
  { key: 'projectOwner', label: 'Owner' },
  { key: 'projectAddress', label: 'Address' },
  { key: 'projectStatus', label: 'Status' },
];

/**
 * Shared header for all QR public pages (Equipment, Device, Panel).
 * Renders: Specard logo, page title, entity tag/name, QR code, and Project Information section.
 */
export const PublicQrPageHeader = ({ title, tagLabel, tagValue, qrToken, data }) => {
  const qrUrl = qrToken ? buildQrUrl(qrToken) : '';
  const projectFields = PROJECT_FIELDS.filter(f => data[f.key]);

  return (
    <>
      {/* Brand bar */}
      <div className="bg-white border-b" data-testid="public-brand-header">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3 flex items-center">
          <Logo size="sm" showText={false} />
          <span className="text-sm font-semibold text-slate-700 ml-2">Specard Inc.</span>
        </div>
      </div>

      <div className="max-w-5xl mx-auto py-4 sm:py-6 px-4 sm:px-6">
        {/* Title + Tag + QR */}
        <div className="flex items-start justify-between mb-4">
          <div>
            <h1 className="text-xl sm:text-2xl font-bold text-slate-800" data-testid="public-page-title">{title}</h1>
            {tagValue && (
              <p className="text-base font-semibold text-orange-600 mt-1" data-testid="public-entity-tag">
                {tagLabel && <span className="text-xs font-medium text-slate-500 uppercase tracking-wide mr-2">{tagLabel}</span>}
                {tagValue}
              </p>
            )}
          </div>
          {qrUrl && (
            <div className="shrink-0 ml-4" data-testid="public-qr-code">
              <QRCodeSVG value={qrUrl} size={96} level="L" />
            </div>
          )}
        </div>

        {/* Project Information */}
        {projectFields.length > 0 && (
          <div className="bg-white rounded-lg border shadow-sm p-4 sm:p-6 mb-4" data-testid="public-project-info">
            <h2 className="text-sm font-semibold text-slate-700 uppercase tracking-wide mb-3">Project Information</h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-3">
              {projectFields.map(f => (
                <div key={f.key}>
                  <dt className="text-[11px] font-medium text-slate-500 uppercase tracking-wide">{f.label}</dt>
                  <dd className="text-sm text-slate-900 font-medium mt-0.5">{data[f.key]}</dd>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};
